"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Text = require("../Text");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  base: "cursor-pointer hover:underline focus:rounded-8 focus:outline-3667e9",
  itemsCenter: "inline-flex items-center",
  default: "text-primary-3667e9",
  danger: "text-red-c34648",
  dark: "text-gray-65657b"
};
const getVariant = size => {
  if (size === "tiny") {
    return "tiny-md";
  } else if (size === "sm") {
    return "small-md";
  } else {
    return "body-md";
  }
};
const Link = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    size = "md",
    color = "default",
    leadingIcon,
    trailingIcon,
    asButton = false,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Text.Text, _extends({
    as: asButton ? "button" : "a",
    ref: ref,
    variant: getVariant(size),
    className: (0, _classnames.default)(THEME.base, THEME[color], {
      [THEME.itemsCenter]: leadingIcon || trailingIcon
    }, className)
  }, props), leadingIcon ? /*#__PURE__*/_react.default.cloneElement(leadingIcon, {
    "aria-hidden": true,
    className: "inline-block mr-4"
  }) : "", children, trailingIcon ? /*#__PURE__*/_react.default.cloneElement(trailingIcon, {
    "aria-hidden": true,
    className: "inline-block ml-4"
  }) : "");
});
exports.Link = Link;
Link.displayName = "Link";